export const MUT_RESET = 'MUT_RESET';
export const MUT_SET_TRADEMARK_WORD = 'MUT_SET_TRADEMARK_WORD';
export const MUT_SET_TRADEMARK_IMAGE = 'MUT_SET_TRADEMARK_IMAGE';
export const MUT_SET_TRADEMARK_IMAGE_REF = 'MUT_SET_TRADEMARK_IMAGE_REF';
